const SectionTitle = ({ title, subTitle, color }) => {
    return (
        <div className={`pt-20 text-center px-10 ${!color ? 'text-white' : color}`}>
            <p className="text-2xl md:text-3xl lg:text-4xl font-semibold uppercase">{title}</p>
            <p className="text-xs md:text-sm lg:text-base lowercase">{subTitle}</p>
        </div>
    )
}

export default SectionTitle